module.exports = __webpack_public_path__ + "static/media/MWD.490a5f5e.png";